// client/src/dnd/views/Interactive_parts/PersonalPinModal.js
import React from "react";

function PersonalPinModal({
  modalPin,
  editPinIdx,
  onChangeLabel,
  onSave,
  onDelete,
  onCancel,
}) {
  if (!modalPin) return null;

  const hasPosition =
    modalPin.x !== undefined && modalPin.y !== undefined;

  return (
    <div
      style={{
        position: "fixed",
        left: "50%",
        top: "36%",
        transform: "translate(-50%, -50%)",
        background: "#23242a",
        padding: 24,
        borderRadius: 14,
        color: "#fff",
        zIndex: 2200,
        boxShadow: "0 4px 28px #000a",
        minWidth: 320
      }}
    >
      <div style={{ marginBottom: 13, fontWeight: 600, fontSize: 16 }}>
        {editPinIdx === null ? "Add Personal Pin" : "Edit Personal Pin"}
      </div>
      <div style={{ marginBottom: 8, fontSize: 14, color: "#ffd" }}>
        Set pin location by clicking the map, then write your note and pick a colour.
      </div>
      <div style={{ marginBottom: 8 }}>
        <input
          type="text"
          placeholder="Your note here..."
          value={modalPin.label}
          onChange={e => onChangeLabel(e.target.value)}
          style={{
            width: "100%",
            padding: 8,
            borderRadius: 7,
            border: "1px solid #888",
            background: "#19191e",
            color: "#fff",
            fontSize: 15
          }}
        />
      </div>
      <div style={{ marginBottom: 10, color: "#bbb", fontSize: 13 }}>
        {hasPosition
          ? `Position: (${Math.round(modalPin.x)}, ${Math.round(modalPin.y)})`
          : "No pin position set yet."}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 11,
          marginTop: 4
        }}
      >
        <button
          style={{
            background: "#4cc153",
            color: "#fff",
            border: "none",
            borderRadius: 7,
            padding: "4px 16px",
            fontWeight: 600,
            fontSize: 15,
            cursor: "pointer"
          }}
          onClick={onSave}
          disabled={!hasPosition}
        >
          Save Pin
        </button>
        {editPinIdx !== null && (
          <button
            style={{
              background: "#f44c2b",
              color: "#fff",
              border: "none",
              borderRadius: 7,
              padding: "4px 14px",
              fontWeight: 600,
              fontSize: 15,
              cursor: "pointer"
            }}
            onClick={onDelete}
          >
            Delete
          </button>
        )}
        <button
          style={{
            background: "none",
            border: "1px solid #aaa",
            borderRadius: 7,
            color: "#fff",
            padding: "4px 16px",
            fontWeight: 600,
            fontSize: 15,
            cursor: "pointer"
          }}
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default PersonalPinModal;
